// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"613":"b5c2f930","764":"298ef83a"}[chunkId] + ".css";
};